import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const RangeForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [RateOptions, setRateOptions] = useState([])

    const [formData, setFormData] = useState({
        from_range: "",
        to_range: "",
        price: "",
        base: null,
        base_price: null,
        rate_id: "",
    })
    const {from_range, to_range, price, base, base_price, rate_id} = formData

    const navigate = useNavigate()

    const loadOptions = async (url, query, setOptions) => {
        const params = { q: query };
        try {
            const response = await Server.get(`/options/${url}`, {params});
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const RangeData = {from_range, to_range, price, base, base_price, rate_id}
        addRange(RangeData)
    }
    
    // add range
    const addRange = async (RangeData) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/ranges/', RangeData)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/ranges')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail)
            }
        }

    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Range</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="rate_id"
                                label="Rate"
                                value={rate_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('rates', query, setRateOptions)}
                                options={RateOptions}
                                placeholder="Start typing to search..."
                                error={errors.rate_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="From Range"
                                name="from_range"
                                type="number"
                                label="From"
                                required="required"
                                value={from_range}
                                onChange={onChange}
                                error={errors.from_range}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="To Range"
                                name="to_range"
                                type="number"
                                label="To"
                                value={to_range}
                                onChange={onChange}
                                error={errors.to_range}
                            />
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-4">
                            <InputField
                                placeholder="Price"
                                name="price"
                                type="number"
                                label="Price"
                                value={price}
                                onChange={onChange}
                                error={errors.price}
                            />
                        </div> 
                        <div className="col-md-4">
                            <NullableInput
                                placeholder="Base (Optional)"
                                name="base"
                                type="number"
                                label="Base"
                                value={base}
                                onChange={onChange}
                                error={errors.base}
                            />
                        </div>
                        <div className="col-md-4">
                            <NullableInput
                                placeholder="Base Price (Optional)"
                                name="base_price"
                                type="number"
                                label="Base Price"
                                value={base_price}
                                onChange={onChange}
                                error={errors.base_price}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Range" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default RangeForm
